import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFetchVisitParts from '../../../hooks/visit/parts/useFetchVisitParts';
import { setSelectedVisitPartAction } from '../../../redux/actions/visitPartsActions';
import Price from '../../shared/price/Price';
import EmptyContent from '../../shared/table/EmptyContent';
import VisitPartsTable from './VisitPartsTable';
import DeleteVisitPartModal from './modals/DeleteVisitPartModal';
import UpdateVisitPartModal from './modals/UpdateVisitPartModal';

const VisitPartsList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const totalPrice = useSelector((state) => state.visitParts?.totalPrice);
  const { loading, visitParts, refresh } = useFetchVisitParts(vin, id);

  const [showUpdateVisitPartModal, setShowUpdateVisitPartModal] = useState(false);
  const [showDeleteVisitPartModal, setShowDeleteVisitPartModal] = useState(false);

  const handleVisitPartClick = (visitPart) => {
    dispatch(setSelectedVisitPartAction(visitPart));
    setShowUpdateVisitPartModal(true);
  };

  const handleUpdateVisitPartModalSubmit = async () => {
    refresh();
    setShowUpdateVisitPartModal(false);
  };

  const handleVisitPartDeleteClick = (visitPart) => {
    dispatch(setSelectedVisitPartAction(visitPart));
    setShowDeleteVisitPartModal(true);
  };

  const handleDeleteVisitPartModalSubmit = async () => {
    refresh();
    setShowDeleteVisitPartModal(false);
  };

  return (
    <div className="flex flex-col items-center">
      {showUpdateVisitPartModal && (
        <UpdateVisitPartModal
          readOnly={readOnly}
          onModalSubmit={() => handleUpdateVisitPartModalSubmit()}
          onModalClose={() => setShowUpdateVisitPartModal(false)}
        />
      )}
      {showDeleteVisitPartModal && (
        <DeleteVisitPartModal
          onModalSubmit={() => handleDeleteVisitPartModalSubmit()}
          onModalClose={() => setShowDeleteVisitPartModal(false)}
        />
      )}
      <VisitPartsTable
        onVisitPartClick={handleVisitPartClick}
        onVisitPartDeleteClick={handleVisitPartDeleteClick}
        visitParts={visitParts}
        readOnly={readOnly}
        loading={loading}
      />
      {visitParts.length === 0 ? (
        <EmptyContent title={'Список деталей візиту порожній'} />
      ) : (
        <Price price={totalPrice} />
      )}
    </div>
  );
};

export default memo(VisitPartsList);
